import React, { useEffect, useState } from 'react';
import { Box, Button, ButtonGroup, Container, Grid, Modal, Paper, Stack, TextField, Typography } from '@mui/material';
import Hacker from '../../common/images/hacker.png';
import Hacker2 from '../../common/images/hacker2.png';
import SimAppCount from '../../common/images/sim_app_count.png';
import Styles from '../../common/styles/styles';
import { toast } from 'react-toastify';
import { useSimulator } from '../../../simulatorContext';
import { useUser } from '../../../userContext';

export default function SimModal({ title, item, onTriggerCloseSimModal }) {  

    const [loading, setLoading] = useState(true);
    const [simData, setSimData] = useState([]);
    const [formData, setFormData] = useState({ description: '', media: '' });
    const [count, setCount] = useState(0);
    const { updateRecordId, updateSimulatorId, updateSimulator, updateExecuted } = useSimulator();
    const { userId } = useUser();

    const applicationData = { ip_dns: '10.1.2.17', collector: 'sensor-001', name: 'python39-setuptools', port: null, authorized: false, notes: 'Hacker Attack', created_by_id: userId };
    const serviceData = { ip_dns: '10.1.2.189', collector: 'sensor-001', name: 'McAfee', port: 8081, authorized: false, notes: 'Hacker Attack', created_by_id: userId };
    const simTypeId = item.simTypeId;
    const simType = item.simType;

    let video = '';
    let appData = '';

    if (title === 'Application Active Response') {
        video = Hacker;
        appData = applicationData;
    } else if (title === 'Service Active Response') {
        video = Hacker2;
        appData = serviceData;
    }
    
    const fetchSimData = async () => {
        try {
                
            const response = await fetch(`${process.env.REACT_APP_API}/simulator/${simTypeId}`);
            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                setSimData(json.data);
                if (simData[count]) {
                    setFormData({ ...formData, description: json.data[count].description.trim(), media: json.data[count].media.trim() });
                }
            }
        } catch (error) {
            toast.error(error);
        } 
    }

    const createApplicationRecord = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API}/applications`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(appData),
            });

            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                toast.success(`Alert Successfully Created`);
                const data = await response.json();                
                return data.id;
            }
        } catch (error) {
            toast.error(error);
        } 
    }

    const updateSimulatorContext = async(id) => {
        updateRecordId(id);
        updateSimulatorId(simTypeId);
        updateSimulator(simType);
        updateExecuted(true);
    }

    const handleClose = () => {
        onTriggerCloseSimModal();        
    }

    const handleNext = async () => {
        setLoading(true);
        setCount(prevCount => prevCount + 1);
        
        if ( (simData[count]) && (simData.length -1 != count) ) {
            setFormData({ ...formData, description: simData[count].description, media: simData[count].media });
            setLoading(false);
        } else {        
            const recordId = await createApplicationRecord();
            await updateSimulatorContext(recordId);
            onTriggerCloseSimModal();
        }
        
    }

    useEffect( () => {
        fetchSimData();
        setLoading(false);
        
    }, [simData]);

    useEffect( () => {
        console.log(`Count Has Been Updated To : ${count}`);
        
    }, [count]);

    if (!loading) {
        return (
            <Container sx={{ minWidth:2400, minHeight: 800, mt: 10, mb: 1, overflowY: 'auto',  }}>
                <Modal 
                    open={true} 
                    onClose={handleClose}
                    style={{
                        overlay: {
                            backgroundColor: '#080030', // Semi-transparent black
                        },
                        content: {
                            backgroundColor: '#080030',
                        },
                    }}
                >
                    <Box sx={{color: 'white', p: 4}}>
                        <Box
                            component={Paper}
                            elevation={3}
                            sx={{
                                mx: 'auto',
                                bgcolor: '#1e1e1e',
                                p: 2,
                                position: 'absolute',
                                top: '10%',
                                left: '25%',
                                height: '80%', 
                                width: '825px',
                                overflowY: 'auto', 
                            }}

                        >
                            <Typography variant="h4" component="h2" color="white" mb={2}>
                                {title}
                            </Typography>
                            { 
                                formData.media !== "" && formData.description === "" ?
                                (
                                    <Grid
                                        item 
                                        container 
                                        xs={20}
                                        direction='row'
                                        sx={{
                                            bgcolor: '#1e1e1e',
                                            overflowY: 'auto', 
                                        }}
                                        
                                        
                                    >
                                    
                                        <Stack sx={{ alignItems: "center" }}>
                                            <img
                                                src={ SimAppCount }
                                                style={{ width: 800, marginRight: 8 }} 
                                            /> 
                                        </Stack>
                                    
                                    </Grid>
                                ) : 
                                formData.media !== "" ?
                                    (
                                        <Grid
                                            item 
                                            container 
                                            xs={12}
                                            direction='row'
                                            sx={{
                                                bgcolor: '#1e1e1e',
                                                overflowY: 'auto', 
                                            }}
                                            
                                            
                                        >
                                        
                                            <Stack sx={{ alignItems: "center" }}>
                                                <img
                                                    src={ video }
                                                    style={{ width: 800, height: 200, marginRight: 8 }} 
                                                /> 
                                            </Stack>
                                            <Stack
                                                sx={{
                                                alignItems: "center",
                                                direction: "column",
                                                flexGrow: 1
                                                }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={10}
                                                    maxRows={22}
                                                    value={formData.description}
                                                    sx={ Styles.textFieldStyles }
                                                />
                                            </Stack>
                                        
                                        </Grid>
                                    ) : (
                                        <Grid
                                            item 
                                            container 
                                            xs={12}
                                            direction='row'
                                            sx={{
                                                bgcolor: '#1e1e1e',
                                                overflowY: 'auto', 
                                            }}
                                        >
                                            <TextField
                                                fullWidth
                                                multiline
                                                minRows={15}
                                                maxRows={22}
                                                value={formData.description}
                                                sx={ Styles.textFieldStyles }
                                            />
                                        </Grid>
                                    )
                                }
                            <ButtonGroup 
                                size="small"
                                variant="contained" 
                                aria-label="Basic button group" 
                                fullWidth
                                sx={{ mt:2 }}
                            >
                                <Button
                                    onClick={handleClose}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Close'}
                                </Button>

                                <Button
                                    onClick={handleNext}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        ml: 5,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Next'}
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Box>
                </Modal>
            </Container>
        )
    }
}